import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, Send, Phone } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { api, formatApiError, UNLOCK_COST } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const ContactLinks = ({ contacts, testid }) => (
  <span className="flex flex-wrap gap-4 text-xs text-neutral-300" data-testid={testid}>
    <span className="flex items-center gap-1"><Mail className="w-3 h-3 text-[#D4AF37]" />{contacts.email}</span>
    {contacts.telegram && (
      <a href={`https://t.me/${contacts.telegram}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 hover:text-[#D4AF37] transition-colors">
        <Send className="w-3 h-3 text-[#D4AF37]" />@{contacts.telegram}
      </a>
    )}
    {contacts.phone && (
      <a href={`tel:${contacts.phone.replace(/[^+\d]/g, "")}`} className="flex items-center gap-1 hover:text-[#D4AF37] transition-colors" data-testid={`${testid}-phone`}>
        <Phone className="w-3 h-3 text-[#D4AF37]" />{contacts.phone}
      </a>
    )}
  </span>
);

export const UnlockButton = ({ hostess, onUnlocked, className = "", testid }) => {
  const { user, setUser } = useAuth();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const enough = (user?.credits ?? 0) >= UNLOCK_COST;

  const unlock = async () => {
    setLoading(true);
    try {
      const r = await api.post(`/hostesses/${hostess.id}/unlock`);
      setUser({ ...user, credits: r.data.credits });
      toast.success("Contatti sbloccati");
      onUnlocked(r.data.contacts);
    } catch (e) { toast.error(formatApiError(e)); } finally { setLoading(false); setOpen(false); }
  };

  return (
    <>
      <button onClick={() => setOpen(true)} className={className} data-testid={testid}><Lock className="w-3.5 h-3.5" /> Sblocca contatti · {UNLOCK_COST} crediti</button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="bg-[#121418] border-white/10 rounded-sm" data-testid="unlock-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-serif text-3xl font-normal">Sbloccare i contatti di {hostess.name}?</AlertDialogTitle>
            <AlertDialogDescription className="text-neutral-400">
              {enough ? `Verranno scalati ${UNLOCK_COST} crediti (saldo attuale: ${user?.credits}). Vedrai Telegram, email ed eventuale telefono per sempre.`
                : `Ti servono ${UNLOCK_COST} crediti, ne hai ${user?.credits ?? 0}.`}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="rounded-none bg-transparent border-white/20" data-testid="unlock-cancel-button">Annulla</AlertDialogCancel>
            {enough ? (
              <AlertDialogAction onClick={(e) => { e.preventDefault(); unlock(); }} disabled={loading} className="btn-gold rounded-none" data-testid="unlock-confirm-button">{loading ? "Sblocco…" : "Conferma"}</AlertDialogAction>
            ) : (
              <Link to="/crediti" className="btn-gold" data-testid="unlock-buy-credits-link">Acquista crediti</Link>
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
